/**
 * @see https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories
 */
export const UpLoadingQueryKeys = {
  all: ['user'] as const,
  lists: () => [...UpLoadingQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...UpLoadingQueryKeys.lists(), { filters }] as const,
  details: () => [...UpLoadingQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...UpLoadingQueryKeys.details(), id] as const,
};
